// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"119":"edde2081","9615":"bb275c0e"}[chunkId] + ".chunk.css";
};